(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (async() => {
    while(!window.hasOwnProperty("jQuery")) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById("ZlistWishlist");
    if (targetNode != undefined) {

      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList" && $(targetNode).hasClass('not-initialized')) {
            // initialization performed on window.resize
            $(targetNode).removeClass('not-initialized')
            $(window).trigger('resize');
          }
        }
      };

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      $('[data-faq2do]').each(function () {        
        $('#scroll-to-section').append('<li class="nav-item"><a href="#'+ $(this).attr('id') +'" class="scrollspy-link">'+ $(this).find('.accordion-title').html() +'</a></li>');
        let item = $(this).detach();
        item.appendTo('#faq-content-list');
      });
      $('#scroll-to-section').find("a.scrollspy-link").first().addClass('active');
      $('#faq-content-list').find('.section').removeClass('d-none');

      scrollSpy('#scroll-to-section', {
        sectionClass: '.scrollspy',
        targetSelector: '.scrollspy-link',
        offset: 300
      });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
  (async() => {
    while(!window.hasOwnProperty("jQuery")) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById("KlaviyoProductReviews");
    if (targetNode != undefined) {

      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {          
            let KlaviyoReviews_ReviewAuthor = document.getElementsByClassName("kl_reviews__review__author");
            Array.prototype.forEach.call(KlaviyoReviews_ReviewAuthor, function(author) {
              shpCustom.KlaviyoReviewsReviewAuthorProcess(author);
            });
          }
        }
      };

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zooomy-wishlist"]) return;
  try {
    
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById("ZoomyWishlistPage");

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          let ZoomyWishlistPageGrid = document.getElementsByClassName("ZoomyWishlistPageGrid");
          Array.prototype.forEach.call(ZoomyWishlistPageGrid, function(gridItem) {
            shpCustom.ZoomyWishlistPageGridItem(gridItem.id);
          });
          
          let login2change = $('#cart').find('.zwishmsgs a[href$="/account/login"]')
          if (login2change.length>0) {
            login2change.attr('href', $('meta[name="shpBaseDir"]').attr('content') + '/account/login');
          }

          targetNode.classList.remove("d-none")
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

  })();

  } catch(e) { console.error(e); }
})();
})();
